module.exports = __webpack_public_path__ + "img/clock-icon.b38646ca.svg";